/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    pageTitle: '',
    showLoading: false,
    showPageTitle: true,
    showToggleButton: true,
    showSearchBox: false,
    showFilterButton: false,
    showReturnButton: false,
    showSaveButton: false,
    saveState: false,
    formatDates: '',
    symbolStyles: '',
    currencySymbols: '',
    version: process.env.PACKAGE_VERSION,
}

const getters = {
    getPageTitle: state => {
        return state.pageTitle
    },
    getShowPageTitle: state => {
        return state.showPageTitle
    },
    getShowToggleButton: state => {
        return state.showToggleButton
    },
    getShowSearchBox: state => {
        return state.showSearchBox
    },
    getShowFilterButton: state => {
        return state.showFilterButton
    },
    getShowReturnButton: state => {
        return state.showReturnButton
    },
    getShowSaveButton: state => {
        return state.showSaveButton
    },
    getSaveState: state => {
        return state.saveState
    },
    getFormatDate: state => {
        return state.formatDates
    },
    getVersion: state => {
        return state.version
    }
}

const mutations = {
    changePage(state, {
        pageName
    }) {
        state.pageTitle = 'menu.' + pageName
    },
    setShowLoading(state, status) {
        state.showLoading = status
    },
    setPageTitle(state, text) {
        state.pageTitle = text
    },
    setToolbar(state, patternTool) {
        switch (patternTool) {
            case "1": // ไว้ใช้กับหน้า List
                state.showPageTitle = false
                state.showToggleButton = true
                state.showSearchBox = true
                state.showFilterButton = true
                state.showReturnButton = false
                state.showSaveButton = false
                break;
            case "2": // ไว้ใช้กับหน้า Create และ Edit
                state.showPageTitle = true
                state.showToggleButton = false
                state.showSearchBox = false
                state.showFilterButton = false
                state.showReturnButton = true
                state.showSaveButton = true
                break;
            default:
                state.showPageTitle = true
                state.showToggleButton = true
                state.showSearchBox = false
                state.showFilterButton = false
                state.showReturnButton = false
                state.showSaveButton = false
                break;
        }
    },
    setSaveState(state, status) {
        state.saveState = status
    },
    setFormatDate(state, text) {
        state.formatDates = text
    },
    setSymbolStyles(state, text) {
        state.symbolStyles = text
    },
    setCurrencySymbols(state, text) {
        state.currencySymbols = text
    },
    setApplogout(state){
        state.pageTitle='',
        state.showLoading= false,
        state.showPageTitle= true,
        state.showToggleButton= true,
        state.showSearchBox= false,
        state.showFilterButton= false,
        state.showReturnButton= false,
        state.showSaveButton= false,
        state.saveState= false,
        state.formatDates= '',
        state.symbolStyles= '',
        state.currencySymbols= ''
    }
}

const actions = {
    changePage({
        commit
    }, {
        pageName
    }) {
        commit("changePage", {
            pageName: pageName
        })
    },
    setPageTitle({
        commit
    }, text) {
        commit("setPageTitle", 'menu.' + text)
    },
    commitSetShowLoading({
        commit
    }, status) {
        commit("setShowLoading", status)
    },
    commitSetToolbar({
        commit
    }, {
        patternTool
    }) {
        commit("setToolbar", patternTool)
    },
    commitSetSaveState({
        commit
    }, {
        status
    }) {
        commit("setSaveState", status)
    },
    commitGeneralSetting({ commit }, {format_date, symbol_styles, currency_symbols}) {
        commit("setFormatDate", format_date)
        commit("setSymbolStyles", symbol_styles)
        commit("setCurrencySymbols", currency_symbols)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}